import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IDNPaymentFilter, IDNPaymentResponse } from 'src/app/class/datatype';
import { environment } from 'src/environments/environment';

@Injectable()
export class IdnPaymentService {
  constructor(private http: HttpClient) {}

  listPayment(filter: IDNPaymentFilter): Observable<IDNPaymentResponse> {
    let params = new HttpParams();

    if (filter.regcode) {
      params = params.append('regcode', filter.regcode.toString());
    }

    if (filter.ref_number) {
      params = params.append('ref_number', filter.ref_number.toString());
    }

    if (filter.bill_component_id) {
      params = params.append(
        'bill_component_id',
        filter.bill_component_id.toString()
      );
    }

    if (filter.merchant_ref_number) {
      params = params.append(
        'merchant_ref_number',
        filter.merchant_ref_number.toString()
      );
    }

    if (filter.nominal) {
      params = params.append('nominal', filter.nominal.toString());
    }

    if (filter.startDate) {
      params = params.append('startDate', filter.startDate.toString());
    }

    if (filter.endDate) {
      params = params.append('endDate', filter.endDate.toString());
    }

    params = params.append('page', filter.page.toString());
    params = params.append('per_page', filter.per_page.toString());

    return this.http.get<IDNPaymentResponse>(
      environment.apiUrl + 'clientapi/idn-payment',
      { params }
    );
  }
}
